import _ from 'lodash'
import hoverTransition from '../editSlide/modules/RightPanel/LinkSettings/HoverAnimation/hoverTransition';
import boxAndButtonTransitionsIn from '../editSlide/modules/RightPanel/AnimationSettings/Appearance/boxAndButtonTransitionsIn';
import boxAndButtonTransitionsOut from '../editSlide/modules/RightPanel/AnimationSettings/Disappearance/boxAndButtonTransitionsOut';
import textTransitionsIn from '../editSlide/modules/RightPanel/AnimationSettings/Appearance/textTransitionsIn';
import textTransitionsOut from '../editSlide/modules/RightPanel/AnimationSettings/Disappearance/textTransitionsOut';
import { defaultBoxCaption, defaultButtonCaption, defaultSettingsState, defaultShapeCaption, defaultCaptionState } from '../defaulState'
import { ARROWS_DESIGN } from './helpers';
// only for caption width "white-space: nowrap"
export const getCaptionWidth = (text, fontSize, lineHeight, fontFamily, style, padding, borderWidth) => {
    let canvas = getCaptionWidth.canvas || (getCaptionWidth.canvas = document.createElement("canvas"));
    let cssStyle = `${style.bold ? 'bold' : ''}, ${style.italic ? 'italic' : ''}, ${style.underline ? 'underline' : ''}`;
    let textStyle = `${cssStyle} ${fontSize}px ${fontFamily}`;
    let context = canvas.getContext("2d");
    let textLines = text.split('\n');
    let lineWidth = 0;
    let maxLineWidth = 0;

    context.font = textStyle

    _.each(textLines, (line, index) => {
        lineWidth = context.measureText(line).width
        if (lineWidth > maxLineWidth) maxLineWidth = lineWidth
    })

    return maxLineWidth + 2 * (parseInt(padding) + parseInt(borderWidth))
};


export const getCaptionHeight = (text, fontSize, lineHeight, fontFamily, style, padding, borderWidth) => {
    let canvas = getCaptionWidth.canvas || (getCaptionWidth.canvas = document.createElement("canvas"));
    let cssStyle = `${style.bold ? 'bold' : ''}, ${style.italic ? 'italic' : ''}, ${style.underline ? 'underline' : ''}`;
    let textStyle = `${cssStyle} ${fontSize}px ${fontFamily}`;
    let context = canvas.getContext("2d");
    let textLines = text.split('\n');
    let lineWidth = 0;
    let maxLineWidth = 0;

    context.font = textStyle

    _.each(textLines, (line, index) => {
        lineWidth = context.measureText(line).width
        if (lineWidth > maxLineWidth) maxLineWidth = lineWidth
    })

    return maxLineWidth + 2 * (parseInt(padding) + parseInt(borderWidth))
}

export function upFirstLetter(string) {
    let str = _.cloneDeep(string)
    return str[0].toUpperCase() + str.slice(1)
}

// ==================== работа с параллаксом ==================================
function getWidgetCurrentSize(compId) {
    const dataName = 'widget-data-'.concat(compId) || {};
    const SStorageWidgetData = JSON.parse(sessionStorage.getItem(dataName)) || {};
    const currentWidth = SStorageWidgetData.width
    const currentHeight = SStorageWidgetData.height
    const currentWidthMobile = SStorageWidgetData.mobileWidth
    const currentHeightMobile = SStorageWidgetData.mobileHeight
    return { currentWidth, currentHeight, currentWidthMobile, currentHeightMobile }
}

function setImageSettingsInFirstLoad(originWidth, originHeight, widgetWidth, widgetHeight) {
    // console.log('originWidth, originHeight, widgetWidth, widgetHeight',originWidth, originHeight, widgetWidth, widgetHeight);
    const additionalOffsetX = 50
    const additionalOffsetY = 50
    const virtualWidth = widgetWidth + additionalOffsetX * 2
    const virtualHeight = widgetHeight + additionalOffsetY * 2
    // const imgRatio = originHeight / originWidth
    const widgetRatio = virtualHeight / virtualWidth

    let offsetX = -additionalOffsetX
    let offsetY = -additionalOffsetY
    let scale = virtualWidth / widgetWidth
    // на случай, если в знаменателе 0, ставим значение по умолчанию 1
    const imgOwnRatio = originHeight / originWidth || 1
    // текущая ширина картинки в данных размераж виджета
    let imgCurrentWidth = virtualWidth
    // текущая высота картинки в пикселях
    const imgCurrenHeight = imgCurrentWidth * imgOwnRatio

    // если высота картинки меньше виртуального контейнера
    if (imgCurrenHeight < virtualHeight) {
        const prop = virtualHeight / imgCurrenHeight
        // console.log('scale 1', scale);
        scale = scale * prop
        // позиционируем картинку по центру в горизонтальной плоскости
        offsetX = -(imgCurrentWidth * prop - widgetWidth) / 2
        // console.log('offsetX',offsetX);
    }
    else {
        // если картинка выше, то позоционируем её по центру в вертикальной плоскости
        offsetY = -(imgCurrenHeight - widgetHeight) / 2
    }
    // console.log('scale',scale,'offsetX',offsetX,'offsetY',offsetY);
    return { scale, offsetX, offsetY }



    // if (imgRatio < widgetRatio) {
    //     // если картинка не достаточно высокая и внизу получается белая полоса
    //     return widgetRatio/imgRatio
    // } else {
    //     return 1
    // }
}

// поставить в параллакс новую картинку
export function changeParallaxImage(newVal, compId, callback) {
    const newImage = [{
        fileName: newVal[0].fileName,
        relativeUri: newVal[0].relativeUri,
        width: newVal[0].width,
        height: newVal[0].height,

        mobileScale: newVal[0].mobileScale || 1,
        mobileOffsetX: newVal[0].mobileOffsetX || 0,
        mobileOffsetY: newVal[0].mobileOffsetY || 0,
        offsetX: newVal[0].offsetX || 0,
        offsetY: newVal[0].offsetY || 0,
        scale: newVal[0].scale || 1,
    }]
    const { currentWidth, currentHeight, currentWidthMobile, currentHeightMobile } = getWidgetCurrentSize(compId)
    // новая картинка позиционируется по центру с некоторым запасом с каждой стороны, чтобы был виден эффект параллакса
    const imageParams = setImageSettingsInFirstLoad(newImage[0].width, newImage[0].height, currentWidth, currentHeight)
    const imageParamsMobile = setImageSettingsInFirstLoad(newImage[0].width, newImage[0].height, currentWidthMobile, currentHeightMobile)
    newImage[0].scale = imageParams.scale
    newImage[0].offsetX = imageParams.offsetX
    newImage[0].offsetY = imageParams.offsetY
    newImage[0].mobileScale = imageParamsMobile.scale
    newImage[0].mobileOffsetX = imageParamsMobile.offsetX
    newImage[0].mobileOffsetY = imageParamsMobile.offsetY
    callback({ data: newImage, currentWidth, currentHeight, currentWidthMobile, currentHeightMobile });
    // this.props.dispatch(settingsActions.changeParallaxImage({data: newImage, currentWidth, currentHeight, currentWidthMobile, currentHeightMobile}));
}

export function getStyleConvertedToMobile(desktopValue, diff) {
    let mobileValue = Math.round(desktopValue * diff)
    if (desktopValue >= 1 && mobileValue < 1) {
        mobileValue = 1
    }
    return mobileValue
}

// конвертировать настройки капчи к мобильному виду, если она ещё не была редактирована в мобильном редакторе
// функция используется как при переходе в мобильный редактор,
// так и в виджете, если в мобильном виде присутствуют капчи, которые не редактировались в мобильном редакторе
export function convertCaptionToMobile(caption, diffW, diffH) {
    caption.mobilePosition.x = Math.round(caption.position.x * diffW);
    caption.mobilePosition.y = Math.round(caption.position.y * diffH);
    caption.mobilePosition.relativeX = Math.round(caption.position.relativeX * diffW);
    caption.mobilePosition.relativeY = Math.round(caption.position.relativeY * diffH);
    caption.mobileWidth = Math.ceil(caption.width * diffW);
    caption.mobileHeight = Math.ceil(caption.height * diffH);
    // если у капчи стили были скопированы, то, чтобы их не сбить, адаптируем только положение
    if (!caption.needMobileConvertOnlyPosition) {
        // caption.mobileBorderWidth = caption.borderWidth * diffW;
        caption.mobileBorderWidth = getStyleConvertedToMobile(caption.borderWidth, diffW);
        // caption.mobileLineHeight = caption.lineHeight * diffW;
        if (typeof caption.borderRadius === 'object') {
            caption.mobileBorderRadius = {
                leftBottom: getStyleConvertedToMobile(caption.borderRadius.leftBottom, diffW),
                leftTop: getStyleConvertedToMobile(caption.borderRadius.leftTop, diffW),
                rightBottom: getStyleConvertedToMobile(caption.borderRadius.rightBottom, diffW),
                rightTop: getStyleConvertedToMobile(caption.borderRadius.rightTop, diffW)
                // leftBottom: caption.borderRadius.leftBottom * diffW,
                // leftTop: caption.borderRadius.leftTop * diffW,
                // rightBottom: caption.borderRadius.rightBottom * diffW,
                // rightTop: caption.borderRadius.rightTop * diffW
            }
            caption.separateCornersMobile = caption.separateCorners
        } else {
            caption.mobileBorderRadius = getStyleConvertedToMobile(caption.borderRadius, diffW);
            // caption.mobileBorderRadius = caption.borderRadius * diffW;
        }
        if (caption.padding) {
            caption.mobilePadding = caption.padding * diffW;
        }
        if (caption.fontSize) {
            caption.mobileFontSize = caption.fontSize * diffW * 0.9;
        }
        if (caption.letterSpacing) {
            caption.mobileLetterSpacing = caption.letterSpacing;
        }
    }

    return caption
}

export const getBackgroundGradient = (props) => {
    // оставить проверку на строку, раньше были только строки
    if (!props.backgroundColor) {
        return ''
    }
    if (typeof props.backgroundColor === 'string') {
        return props.backgroundColor
    }
    if (props.backgroundColor.type === 'color') {
        return props.backgroundColor.colorValue;
    } else {
        let gradient = '';
        if (props.stripes) {
            props.backgroundColor.gradientLayers[0].layerColors.push(
                {
                    color: props.backgroundColor.gradientLayers[0].layerColors[0].color,
                    transition: 100
                }
            )
        }
        if (props.backgroundColor.gradientLayers[0].layerColors) {
            props.backgroundColor.gradientLayers.map((layer, index) => {
                let colorStops = ''
                for (let stop of layer.layerColors) {
                    colorStops += `, ${stop.color} ${stop.transition}%`
                }
                gradient = `linear-gradient(${layer.angle}deg${colorStops})` + gradient
                if (index != props.backgroundColor.gradientLayers.length - 1) {
                    gradient = ', ' + gradient
                }
            })
        } else {
            props.backgroundColor.gradientLayers.map((layer, index) => {
                gradient = `linear-gradient(${layer.angle}deg, ${layer.firstColor}, ${layer.secondColor} ${layer.transition}%)` + gradient
                if (index != props.backgroundColor.gradientLayers.length - 1) {
                    gradient = ', ' + gradient
                }
            })
        }

        return gradient
    }
}

// определяем какие капчи премиум не поддерживает
export function setPremiumCaptions(captions, showSmartPremium, showProfessionalPremium) {
    try {
        // если профессионал, то возвращаем те же капчи, удалив на всякий случай отметку о премиуме, если она есть
        if (showProfessionalPremium) {
            return captions.map(caption => {
                delete caption.isPremiumElem
                return caption
            })
        }

        let captionsCount = 0
        // максимальное количество элементов
        const maxCaptions = showSmartPremium ? 20 : 2
        return captions.map(caption => {
            delete caption.isPremiumElem

            if (showSmartPremium || caption.type === 'text' || caption.type === 'shape') {
                if (captionsCount >= maxCaptions) {
                    caption.isPremiumElem = true
                }
                captionsCount++
            } else {
                caption.isPremiumElem = true
            }
            return caption
        })
    }
    catch (e) {
        console.log('captions', captions)
        console.warn(e)
        return {}
    }

}

// получить настройки в виджете соответствующие текущему премиуму пользователя для показа в предпросмотре и на паблише
export function getSettingsCorrectedToPremium(incomingSettingsReducer, viewMode, premiumReducer) {
    const clonedSettings = _.cloneDeep(incomingSettingsReducer)
    // const isEditorMode = false // test
    const isEditorMode = viewMode === 'editor'
    const smartPrem = premiumReducer.showSmartPremiumSettings
    const profPrem = premiumReducer.showProfessionalPremiumSettings // === professional + smart settings
    let settingsWasChangedInCorrectToPremuim = false
    const settingsReducer = _.cloneDeep(clonedSettings)

    // если пакет Professional premium или пользователь в эдиторе, то возвращаем настройки без изменений
    if (profPrem || isEditorMode) {
        return { settingsCorrectedToPremium: clonedSettings, settingsWasChangedInCorrectToPremuim: false }
    }
    // если пакет Smart Premium
    else if (smartPrem) {

        const hoverForbiddenTransition = hoverTransition.filter(transition => transition.professionalPremium === true)
        const boxAndButtonForbiddenAnimationIn = boxAndButtonTransitionsIn.filter(transition => transition.professionalPremium === true)
        const boxAndButtonForbiddenAnimationOut = boxAndButtonTransitionsOut.filter(transition => transition.professionalPremium === true)

        if (clonedSettings.slides.length > 10) {
            settingsWasChangedInCorrectToPremuim = true
        }
        settingsReducer.slides = clonedSettings.slides.splice(0, 10)

        settingsReducer.slides.map(slide => {
            if (slide.isHide) return slide

            const slideCaptionsAfterPremCorrect = setPremiumCaptions(slide.captions, smartPrem, profPrem).filter(caption => !caption.isPremiumElem)

            if (slide.captions.length > slideCaptionsAfterPremCorrect.length) {
                settingsWasChangedInCorrectToPremuim = true
            }
            // const slideCaptionsAfterPremCorrect = slide.captions.splice(0, 20)
            slideCaptionsAfterPremCorrect.map(caption => {
                // console.log('caption',caption)
                if (caption.type === 'button') {
                    if (caption.isHover && hoverForbiddenTransition.some(transition => transition.name === caption.animation.value)) {
                        // ховер анимация кнопки
                        caption.animation = defaultButtonCaption.animation //{ value: 'sweep-to-right', class: 'background', label: 'Sweep to right' }
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (boxAndButtonForbiddenAnimationIn.some(animation => animation.name === caption.animationIn)) {
                        caption.animationIn = defaultButtonCaption.animationIn //'bounceIn'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (boxAndButtonForbiddenAnimationOut.some(animation => animation.name === caption.animationOut)) {
                        caption.animationOut = defaultButtonCaption.animationOut //'bounceOut'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                }
                else if (caption.type === 'shape') {
                    if (boxAndButtonForbiddenAnimationIn.some(animation => animation.name === caption.animationIn)) {
                        caption.animationIn = defaultShapeCaption.animationIn //'bounceIn'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (boxAndButtonForbiddenAnimationOut.some(animation => animation.name === caption.animationOut)) {
                        caption.animationOut = defaultShapeCaption.animationOut //'bounceOut'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                }
                else if (caption.type === 'box') {
                    if (boxAndButtonForbiddenAnimationIn.some(animation => animation.name === caption.animationIn)) {
                        caption.animationIn = defaultBoxCaption.animationIn //'bounceIn'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (boxAndButtonForbiddenAnimationOut.some(animation => animation.name === caption.animationOut)) {
                        caption.animationOut = defaultBoxCaption.animationOut //'bounceOut'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.backgroundColor.type === 'gradient') {
                        caption.backgroundColor.type = 'color'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                }
                return caption
            })
            slide.captions = slideCaptionsAfterPremCorrect
            return slide
        })
    }

    // если бесплатный пакет 
    else {
        const boxAndButtonForbiddenAnimationIn = boxAndButtonTransitionsIn.filter(transition => transition.simplePremium === true)
        const boxAndButtonForbiddenAnimationOut = boxAndButtonTransitionsOut.filter(transition => transition.simplePremium === true)
        const textForbiddenAnimationIn = textTransitionsIn.filter(transition => transition.simplePremium === true)
        const textForbiddenAnimationOut = textTransitionsOut.filter(transition => transition.simplePremium === true)

        if (clonedSettings.slides.length > 3) {
            settingsWasChangedInCorrectToPremuim = true
        }
        settingsReducer.slides = clonedSettings.slides.splice(0, 3)

        // нстройки отдельного слайда
        settingsReducer.slides.map(slide => {
            if (slide.isHide) return slide

            const slideCaptionsAfterPremCorrect = setPremiumCaptions(slide.captions, smartPrem, profPrem).filter(caption => !caption.isPremiumElem)

            if (slide.captions.length > slideCaptionsAfterPremCorrect.length) {
                settingsWasChangedInCorrectToPremuim = true
            }
            // const slideCaptionsAfterPremCorrect = slide.captions.splice(0, 2)

            // настройки отдельной капчи
            slideCaptionsAfterPremCorrect.map(caption => {
                // console.log('caption',caption)
                if (caption.delayIn !== 0) {
                    caption.delayIn = 0
                    settingsWasChangedInCorrectToPremuim = true
                }
                if (caption.delayOut !== 0) {
                    caption.delayOut = 0
                    settingsWasChangedInCorrectToPremuim = true
                }

                if (caption.type === 'text') {
                    if (textForbiddenAnimationIn.some(animation => animation.name === caption.animationIn)) {
                        caption.animationIn = defaultCaptionState.animationIn //'fadeIn'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (textForbiddenAnimationOut.some(animation => animation.name === caption.animationOut)) {
                        caption.animationOut = defaultCaptionState.animationOut //'fadeOut'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.animationModeIn !== defaultCaptionState.animationModeIn) {
                        caption.animationModeIn = defaultCaptionState.animationModeIn
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.animationModeOut !== defaultCaptionState.animationModeOut) {
                        caption.animationModeOut = defaultCaptionState.animationModeOut
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.lineHeight !== defaultCaptionState.lineHeight) {
                        caption.lineHeight = defaultCaptionState.lineHeight
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.mobileLineHeight !== defaultCaptionState.mobileLineHeight) {
                        caption.mobileLineHeight = defaultCaptionState.mobileLineHeight
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.letterSpacing !== defaultCaptionState.letterSpacing) {
                        caption.letterSpacing = defaultCaptionState.letterSpacing
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.mobileLetterSpacing !== defaultCaptionState.mobileLetterSpacing) {
                        caption.mobileLetterSpacing = defaultCaptionState.mobileLetterSpacing
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.letterCase !== defaultCaptionState.letterCase) {
                        caption.letterCase = defaultCaptionState.letterCase
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.hasShadow) {
                        caption.shadow = {
                            angle: 120,
                            distance: 2,
                            x: 2,
                            y: 1,
                            blur: 4,
                            size: 1,
                            color: 'rgba(0,0,0,0.7)',
                        }
                    }
                }
                else if (caption.type === 'button') {
                    caption.desktopHidden = true
                    caption.mobileHidden = true
                    settingsWasChangedInCorrectToPremuim = true
                }

                else if (caption.type === 'shape') {
                    if (boxAndButtonForbiddenAnimationIn.some(animation => animation.name === caption.animationIn)) {
                        caption.animationIn = defaultShapeCaption.animationIn //'bounceIn'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (boxAndButtonForbiddenAnimationOut.some(animation => animation.name === caption.animationOut)) {
                        caption.animationOut = defaultShapeCaption.animationOut //'bounceOut'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.backgroundColor.type === 'gradient') {
                        caption.backgroundColor.type = 'color'
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.hasShadow) {
                        caption.shadow = {
                            angle: 120,
                            distance: 2,
                            x: 2,
                            y: 1,
                            blur: 4,
                            size: 1,
                            color: 'rgba(0,0,0,0.7)',
                        }
                        settingsWasChangedInCorrectToPremuim = true
                    }
                    if (caption.effectType != undefined || caption.blur !== undefined) {
                        caption.effectType = 'element'
                        caption.blur = 0
                        caption.glassEffect = 0
                        caption.invertEffect = 0
                        caption.grayscaleEffect = 0
                        settingsWasChangedInCorrectToPremuim = true
                    }
                }

                else if (caption.type === 'box') {
                    caption.desktopHidden = true
                    caption.mobileHidden = true
                    settingsWasChangedInCorrectToPremuim = true
                }

                else if (caption.type === 'image') {
                    caption.desktopHidden = true
                    caption.mobileHidden = true
                    settingsWasChangedInCorrectToPremuim = true
                }
                return caption
            })
            slide.captions = slideCaptionsAfterPremCorrect

            if (slide.hasBackgroundShadow) {
                slide.backgroundShadow = {
                    angle: 0,
                    distance: 0,
                    x: 0,
                    y: 0,
                    blur: 20,
                    size: 10,
                    color: 'rgba(0,0,0,0.3) inset',
                }
            }

            if (slide.backgroundType === 'gradient') {
                slide.backgroundType = 'color'
                settingsWasChangedInCorrectToPremuim = true
            }

            return slide
        })

        // общие настройки виджета
        if (settingsReducer.backgroundType === 'gradient') {
            settingsReducer.backgroundType = 'color'
            settingsWasChangedInCorrectToPremuim = true
        }
        if (settingsReducer.arrows > 1) {
            settingsReducer.arrows = 0
            settingsWasChangedInCorrectToPremuim = true
        }
        if (settingsReducer.animationMode !== 'none') {
            settingsReducer.animationMode = 'none'
            settingsWasChangedInCorrectToPremuim = true
        }
        if (settingsReducer.hasNavigationOnHover) {
            settingsReducer.hasNavigationOnHover = false
            settingsWasChangedInCorrectToPremuim = true
        }
        if (settingsReducer.hasParallax) {
            settingsReducer.hasParallax = false
            settingsWasChangedInCorrectToPremuim = true

            // при отключении картинки, возвращаю непрозрачность для фона слайдера
            settingsReducer.slides.map(slide => {
                const regex = /(\d+(\.\d+)?\))/;
                const opacityBackground = slide.backgroundColor.match(regex)[0]
                slide.backgroundColor = slide.backgroundColor.replace(opacityBackground, 1 + ')')
            })
        }

        if (settingsReducer.backgroundType !== 'none') {
            settingsReducer.backgroundType = 'none'
        }

        if (settingsReducer.selectedArrowsDesign != ARROWS_DESIGN.legacy) {
            settingsReducer.selectedArrowsDesign = ARROWS_DESIGN.legacy
        }

        if (settingsReducer.dotsDesign != 'circle-solid') {
            settingsReducer.dotsDesign = 'circle-solid'
        }

    }




    // console.log('settingsReducer after prem convert',settingsReducer)

    return { settingsCorrectedToPremium: settingsReducer, settingsWasChangedInCorrectToPremuim }
}

// подготовка текста для анимации арабских шрифтов
export function flipLeftToRightWords(text) {
    // расшифровка RegExp
    // \s - пробел
    // \w - латинские буквы верхнего и нижнего регистра и цифры
    // \А-Яа-я - кириллица верхнего и нижнего регистра
    // [\s,]{0,1} - пробел или запятая, повторяющиеся от 0 до 1 раз
    // [\wА-Яа-я]+ - буквы или цифры, повторяющиеся любое количество раз в любом порядке
    // (выражение)+ - выражение, повторяющееся любое количество раз
    // /выражение/g - ищем все вхождения, а не только первое
    const re = /([-\s,@\."]{0,1}[\wА-Яа-я0-9٠-٩]+[-\s,@\."]{0,1})+/g;
    let mirroredText = _.cloneDeep(text)
    if (typeof text === 'string') {
        mirroredText = mirroredText.replace(re, word => {
            let wordArray = word.split('')
            // если первый или последний символы - пробелы, то отрезаем их, чтобы потом прилепить на то же место
            let firstLetter = wordArray[0] === ' ' ? [' '] : []
            let lastLetter = wordArray[wordArray.length - 1] === ' ' ? [' '] : []
            // переворачиваем
            let reversedArray = word.trim().split('').reverse()
            // прилепляем крайние пробелы на место и соединяем в слово
            return firstLetter.concat(reversedArray, lastLetter).join('')
        })
    } else if (typeof text === 'object') {
        mirroredText = mirroredText.map(string => string.replace(re, word => word.split('').reverse().join('')))
    }

    return mirroredText
}

// подготовка текста перед отправкой в confifAnimations
export function getCaptionsAdaptedToTypingAnimation(captions) {
    const re = /(?:^|\s|[-"()[\]{}.?;!@#$%^&*+=|<>`~,\\/])+\S/g;

    // при typing анимации текст берётся из configAnimations, а не из DOM
    // поэтому передаём текст в configAnimations, предварительно отредактировав
    return captions.map(caption => {
        if (caption.letterCase === 'capitalize' && caption.animationIn === 'typing') {
            caption.text = caption.text.map(line => line.toLowerCase().replace(re, c => c.toUpperCase()))
        }
        if (caption.animationIn === 'typing') {
            // необходимо убрать не только случайные пробелы по краям, но и переносы строк
            caption.text = caption.text.map(line => line.trim())
        }
        return caption
    })
}

export function correctCaptionsIndexAfterHide(captions) {
    return captions.map((caption, index) => {
        caption.index = index
        return caption
    })
}

// получить массив слайдов, где удалены скрытые слайды
export function getVisibleSlides(slidesArray) {
    let deviceType = 'desktop'
    try {
        deviceType = Wix.Utils.getDeviceType();
    } catch (e) { }

    const slides = _.cloneDeep(slidesArray)

    for (let i = slidesArray.length - 1; i >= 0; i--) {
        if (slidesArray[i].isHide) {
            slides.splice(i, 1)
        }
    }
    // удаляем скрытые капчи
    slides.map(slide => {
        const captions = slide.captions.filter(caption => {
            return (!caption.desktopHidden && !caption.hiddenOutOfBounds && deviceType === 'desktop') || (!caption.mobileHidden && deviceType === 'mobile')
        })
        for (let i = 0; i < captions.length; i++) {
            captions[i].index = i
        }
        slide.captions = captions
        return slide
    })

    return slides
}

//TODO: Спасибо Миша, нужно теперь это удалить.
// получить настройки капчи, зависящие от языка сайта
export function getValueAccordingToLanguage(caption, propName, language, locale) {
    let value = caption[propName]
    if (language && caption.lang) {
        if (caption.lang.hasOwnProperty(language)) {
            value = caption.lang[language][propName]
        } else if (caption.lang.hasOwnProperty(locale)) {
            value = caption.lang[locale][propName]
        }
    }
    return value
}

//TODO: Спасибо Миша, нужно теперь это удалить.
// установить для каждой текстовой капчи настройки языка, на который переключились,
// если этих настроек ещё нет
export function setLanguageSettingsToCaptions(widgetSettings, lang, locale) {
    let settings = _.cloneDeep(widgetSettings)
    settings.slides = settings.slides.map(slide => {
        slide.captions = slide.captions.map(caption => {
            // у всех текстовых капч создаём объект с настройками текста для нового языка
            if (caption.type === 'text' || caption.type === 'button') {
                const captionLangObj = caption.lang || {}

                if (!captionLangObj.hasOwnProperty(lang)) {
                    let copyFromHere = caption
                    // если переключаемся на новый язык, то за шаблон берём текст из 
                    // языка создателя сайта (locale = Wix.Utils.getLocale())
                    if (captionLangObj.hasOwnProperty(locale)) {
                        copyFromHere = captionLangObj[locale]
                    }

                    captionLangObj[lang] = {
                        text: copyFromHere.text,
                        fontFamily: copyFromHere.fontFamily,
                        isRTL: !!copyFromHere.isRTL,
                    }
                    if (caption.type === 'text') {
                        captionLangObj[lang].textArray = copyFromHere.textArray || []
                    }
                    caption.lang = captionLangObj
                }
            }
            return caption
        })
        return slide
    })
    return settings
}

// получаем значение языка из get параметра адресной строки
export async function getSiteLang() {
    const myPromise = new Promise((resolve, reject) => {
        Wix.getSiteInfo((info) => {
            let lang = getParameterByName('lang', info.url)
            resolve(lang)
        })
    })
    return await myPromise
}

function getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getUrlVars() {
    let vars = [],
        hash,
        hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    _.each(hashes, (hashElement) => {
        hash = hashElement.split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    })

    return vars;
};

export function getUrlVar(name) {
    return getUrlVars()[name];
};

export const getOS = () => {
    let OSName = "Unknown"

    if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) OSName = "Windows 10"
    if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1) OSName = "Windows 8.1"
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName = "Windows 8"
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName = "Windows 7"
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName = "Windows Vista"
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName = "Windows XP"
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName = "Windows 2000"
    if (window.navigator.userAgent.indexOf("Mac") != -1) OSName = "Mac/iOS"
    if (window.navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX"
    if (window.navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux"

    return OSName
}


//firefox check close window

const APP_NAME = 'text-slider'


export const setCheckWindowClosed = (windowName = 'settings', compId = '', onCloseWindow = () => { }) => {
    return setInterval(() => {
        const wasWindowOpened = sessionStorage.getItem(`${APP_NAME}-${compId}-firefox-${windowName}-opened`) == 'true'
        const wasWindowClosed = sessionStorage.getItem(`${APP_NAME}-${compId}-firefox-${windowName}-check`) == 'true'

        if (wasWindowOpened && wasWindowClosed) {
            // console.log(`firefox ${windowName} closed`)
            onCloseWindow()
            sessionStorage.removeItem(`${APP_NAME}-${compId}-firefox-${windowName}-opened`)
        } else {
            sessionStorage.setItem(`${APP_NAME}-${compId}-firefox-${windowName}-check`, `true`)
        }
    }, 500)
}

export const openedWindowForClosed = (windowName = 'settings', compId = '') => {

    sessionStorage.removeItem(`${APP_NAME}-${compId}-firefox-${windowName}-check`)
    sessionStorage.setItem(`${APP_NAME}-${compId}-firefox-${windowName}-opened`, `true`)

    return setInterval(() => {
        sessionStorage.setItem(`${APP_NAME}-${compId}-firefox-${windowName}-opened`, `true`)
        sessionStorage.removeItem(`${APP_NAME}-${compId}-firefox-${windowName}-check`)
    }, 10)
}